import Phaser from 'phaser'

export default class Touch extends Phaser.Scene {
  create ({ game, player }) {
    this.player = player

    // this.keyRight = this.input.keyboard.addKey('right')
    // this.keyLeft = this.input.keyboard.addKey('left')

    this.setupBounds()

    // button images:
    this.leftInputImg = this.add.image(0, 0, 'images', 'touch_input')
    this.leftInputImg.setFlipX(true)
    this.leftInputImg.setScrollFactor(0)
    this.leftInputImg.setDepth(1000)
    this.leftInputImg.setAlpha(0.5)

    this.rightInputImg = this.add.image(0, 0, 'images', 'touch_input')
    this.rightInputImg.setScrollFactor(0)
    this.rightInputImg.setDepth(1000)
    this.rightInputImg.setAlpha(0.5)

    // button sensors:
    this.leftInput = this.add.image(0, 0, 'white')
    this.leftInput.setScrollFactor(0)
    this.leftInput.setDepth(1000)
    this.leftInput.setVisible(false)

    this.rightInput = this.add.image(0, 0, 'white')
    this.rightInput.setScrollFactor(0)
    this.rightInput.setDepth(1000)
    this.rightInput.setVisible(false)

    // if (!this.scene.game.device.os.desktop) {
    this.leftInput.setInteractive()
    this.leftInput.input.alwaysEnabled = true
    this.leftInput.on('pointerdown', (pointer, localX, localY, event) => {
      if (localX < 1 && localY < 1) {
        this.player.keyLeft.isDown = true
        this.player.keyLeft.isUp = false
      }
    })
    this.leftInput.on('pointerup', (pointer, localX, localY, event) => {
      this.player.keyLeft.isDown = false
      this.player.keyLeft.isUp = true
    })

    this.rightInput.setInteractive()
    this.rightInput.input.alwaysEnabled = true
    this.rightInput.on('pointerdown', (pointer, localX, localY, event) => {
      if (localX < 1 && localY < 1) {
        this.player.keyRight.isDown = true
        this.player.keyRight.isUp = false
      }
    })
    this.rightInput.on('pointerup', (pointer, localX, localY, event) => {
      this.player.keyRight.isDown = false
      this.player.keyRight.isUp = true
    })
    // }

    this.rotateDeviceIm = this.add.image(0, 0, 'images', 'rotate_device')
    this.rotateDeviceIm.setScrollFactor(0)
    this.rotateDeviceIm.setAlpha(0.5)
    this.rotateDeviceIm.setDepth(1000)
    this.rotateDeviceIm.setVisible(false)
    this.rotateDeviceIm.setScale(0.75)

    this.landscape = window.innerWidth > window.innerHeight
    this.scale.on('resize', () => {
      const oldLS = this.landscape
      this.landscape = window.innerWidth > window.innerHeight
      if (this.landscape !== oldLS) {
        this.onResize()
      }
    })
    this.onResize()
  }

  onResize () {
    if (this.cameras.main) {
      if (this.landscape) {
        this.cameras.main.setZoom(1)// 0.75)
      } else {
        this.cameras.main.setZoom(0.5625) // TODO: find correct value
      }

      if (this.landscape) {
        this.barTop.setVisible(false)
        this.barBtm.setVisible(false)

        const w = this.scale.gameSize.width

        this.leftInput.setPosition(w / 2 - 1280 / 2 - 800 / 2, 500)
        this.leftInput.setSize(2000, 800)
        this.leftInput.setDisplaySize(2000, 800)

        this.rightInput.setPosition(w / 2 + 1280 / 2 + 800 / 2, 500)
        this.rightInput.setSize(2000, 800)
        this.rightInput.setDisplaySize(2000, 800)

        if (this.game.device && this.game.device.os.desktop) {
          this.leftInputImg.setPosition(w / 2 - 560, 660)
          this.rightInputImg.setPosition(w / 2 + 560, 660)

          this.leftInputImg.setScale(0.350)
          this.rightInputImg.setScale(0.350)
        } else {
          this.leftInputImg.setPosition(w / 2 - 560, 510)
          this.rightInputImg.setPosition(w / 2 + 560, 510)

          this.leftInputImg.setScale(0.6)
          this.rightInputImg.setScale(0.6)
        }
      } else {
        this.barTop.setVisible(true)
        this.barBtm.setVisible(true)

        this.leftInput.setPosition(0, 800)
        this.leftInput.setSize(680, 2000)
        this.leftInput.setDisplaySize(680, 2000)

        this.rightInput.setPosition(720, 800)
        this.rightInput.setSize(680, 2000)
        this.rightInput.setDisplaySize(680, 2000)

        this.leftInputImg.setPosition(100, 1200)
        this.leftInputImg.setScale(2)

        this.rightInputImg.setPosition(620, 1200)
        this.rightInputImg.setScale(2)

        this.rotateDeviceIm.setPosition(360, 1650)
        this.rotateDeviceIm.setVisible(true)
      }
    }
  }

  setupBounds () {
    this.barTop = this.add.image(360, -500, 'white')
    this.barTop.setTint(0x333332)
    this.barTop.setDisplaySize(this.scale.gameSize.width * 2, 1000)
    this.barTop.setDepth(-900)

    this.barBtm = this.add.image(360, 1330, 'white')
    this.barBtm.setTint(0x333332)
    this.barBtm.setDisplaySize(this.scale.gameSize.width * 2, 1200)
    this.barBtm.setDepth(-900)

    // this.barTop.setAlpha(0.5)
    // this.barBtm.setAlpha(0.5)
  }

  update (time, delta) {
    if (!this.player.hasStarted && !this.game.device.os.desktop) {
      if (time % 1000 < 500) {
        this.rightInputImg.setAlpha(1)
        this.leftInputImg.setAlpha(0.5)
      } else {
        this.rightInputImg.setAlpha(0.5)
        this.leftInputImg.setAlpha(1)
      }
    } else {
      if (this.player.keyLeft.isDown) {
        this.leftInputImg.setAlpha(1)
      } else {
        this.leftInputImg.setAlpha(0.5)
      }
      if (this.player.keyRight.isDown) {
        this.rightInputImg.setAlpha(1)
      } else {
        this.rightInputImg.setAlpha(0.5)
      }
    }
  }

  enable () {
    if (this.leftInput) {
      this.leftInput.input.alwaysEnabled = true
      this.rightInput.input.alwaysEnabled = true

      this.leftInputImg.setVisible(true)
      this.rightInputImg.setVisible(true)
    }
  }

  disable () {
    if (this.leftInput) {
      this.leftInput.input.alwaysEnabled = false
      this.rightInput.input.alwaysEnabled = false

      this.leftInputImg.setVisible(false)
      this.rightInputImg.setVisible(false)
    }
  }
}
